import { memo, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Transition } from 'react-transition-group';

const duration = 200;

const resultContainerStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
};

const resultTransitionStyles = {
  exiting: { opacity: 1 },
  entered: { opacity: 1 },
  exited: { opacity: 0, display: 'none' },
};

const ResultTransition = memo(({ transitionIn, children }) => (
  <Transition in={transitionIn} timeout={duration} exit={false}>
    {(transitionState) => <div style={{ ...resultContainerStyle, ...resultTransitionStyles[transitionState] }}>{children}</div>}
  </Transition>
));

ResultTransition.displayName = 'ResultTransition';
ResultTransition.propTypes = {
  transitionIn: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

ResultTransition.defaultProps = {
  transitionIn: false,
};

const Loader = ({ loaderComponent: LoaderComponent, isLoading, children }) => (
  <Fragment>
    <ResultTransition transitionIn={isLoading}>
      <LoaderComponent />
    </ResultTransition>
    <ResultTransition transitionIn={!isLoading}>{children}</ResultTransition>
  </Fragment>
);

Loader.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  loaderComponent: PropTypes.elementType.isRequired,
};

export default Loader;
